import WRAP from 'WRAP-JS'
import { COMMUNICATE_ERROR_MESSAGE_AIRPORT, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD } from '../../../constants/ErrorMessage';
import {
  configAirportDh,
  configAirportLayer
} from "./config/ConfigAirport";

export const AIRPORT_LABEL_ICAO = "icao";
export const AIRPORT_LABEL_IATA = "iata";
export const AIRPORT_LABEL_NAME = "airport_name";

class Airport {
  static NAME = "Airport";

  tileIndex;
  dh;
  layer;
  ready = false;
  labelTarget = AIRPORT_LABEL_ICAO;
  isDark;
  contentsDispatcher;
  errorMessageInfo;

  constructor(isDark) {
    this.isDark = isDark;
    this.layer = new WRAP.Geo.Layer(Airport.NAME);
    this.layer.setVisible(false);
    this.layer.disableInteraction(true);
  }

  async initialize() {
    await this.initData();
    this.initLayer();
    this.ready = true;
  }

  initData() {

    this.dh = new WRAP.Data(configAirportDh);
    return new Promise((resolve) => {
      this.dh.updated('index', ref => {
        if (this.errorMessageInfo) {
          this.contentsDispatcher({type: 'CLEAR_ERROR', payload: this.errorMessageInfo});
          this.errorMessageInfo = null;
        }
        if (ref && Array.isArray(ref) && ref.length > 0) {
          this.tileIndex = ref[0].Prefix;
        }
        if (this.tileIndex) {
          resolve();
        }
      }, () => {
        this.errorMessageInfo = this.contentsDispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_AIRPORT,
          replacement: {data: 'index'},
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
        }});
      });
      
      this.dh.updated('data', null, () => {
        this.contentsDispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_AIRPORT,
          replacement: {data: 'data'},
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD
        }});
      });
    });

  }

  initLayer() {
    this.layer.configure(this.dh, configAirportLayer);
    this.layer.set({
      index: this.tileIndex
    });
    this.applyMapColor(null, this.isDark);

    this.layer.setAttributes({
      label_target: this.labelTarget
    });
  }

  async drawLayer(visible) {
    if (!this.ready) {
      await this.initialize();
    }
    this.setVisible(visible);
  }

  getLayer() {
    return this.layer;
  }

  setVisible(visible) {
    if (this.layer.visible() === visible) {
      return;
    }

    if (visible) {
      this.layer.show();
    } else {
      this.layer.hide();
    }
  }

  applyMapColor(mapColor, isDark) {
    this.isDark = isDark;
    const style = this.isDark ? "dark" : "default";
    this.layer.setStyle(style);
  }

  getLabelTarget() {
    return this.labelTarget;
  }

  setLabelTarget(labelTarget) {
    this.labelTarget = labelTarget;
    this.layer.setAttributes({
      label_target: this.labelTarget
    });
  }

  setContentsDispatcher(dispatcher) {
    this.contentsDispatcher = dispatcher;
  }
}

export default Airport;